module.exports = __webpack_public_path__ + "static/media/rotate-b2.2.4fc19462.svg";